export default __webpack_public_path__ + "static/media/8.711f1204.png";